import * as RTabs from '@radix-ui/react-tabs';
import type { ReactNode } from 'react';
import { cn } from './cn';

export interface TabDef {
  value: string;
  label: ReactNode;
  content: ReactNode;
}

export function Tabs({
  tabs,
  value,
  onValueChange,
  defaultValue,
}: {
  tabs: TabDef[];
  value?: string;
  onValueChange?: (v: string) => void;
  defaultValue?: string;
}) {
  return (
    <RTabs.Root value={value} onValueChange={onValueChange} defaultValue={defaultValue ?? tabs[0]?.value}>
      <RTabs.List className="flex gap-lg border-b-[0.5px] border-hairline">
        {tabs.map((t) => (
          <RTabs.Trigger
            key={t.value}
            value={t.value}
            className={cn(
              'relative -mb-[0.5px] pb-sm pt-xs text-small font-medium text-ink-mid outline-none',
              'data-[state=active]:text-accent-blue data-[state=active]:after:absolute data-[state=active]:after:inset-x-0 data-[state=active]:after:bottom-0 data-[state=active]:after:h-[2px] data-[state=active]:after:bg-accent-blue',
              'focus-visible:shadow-focus',
            )}
          >
            {t.label}
          </RTabs.Trigger>
        ))}
      </RTabs.List>
      {tabs.map((t) => (
        <RTabs.Content key={t.value} value={t.value} className="pt-lg focus-visible:outline-none">
          {t.content}
        </RTabs.Content>
      ))}
    </RTabs.Root>
  );
}
